import { fundApiClient } from './client';

/**
 * 優質模擬交易平台CMS API
 * https://fund.api.cnyes.com/fund/api/v1/funds/vendorAds?vendorSlug=forex
 * @returns
 */
export const GETv1SponsorsList = () => {
  const url = '/fund/api/v1/funds/vendorAds?vendorSlug=forex';

  return fundApiClient.get(url, {}, { next: { revalidate: 3600 } });
};
